/** @module csi/widget/Menu */
define([
	"dojo/_base/declare",
	"dijit/Menu",
	"csi/widget/_DropDownMenuMixin"
], function(declare,Menu,DropDownMenuMixin) {

	return declare([Menu,DropDownMenuMixin], {
		popupDelay: 200
	});
});